/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_SubtitleInputs */

const en_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a saved job to generate tailored interview questions.`)
};

const de_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine gespeicherte Stelle, um maßgeschneiderte Interviewfragen zu generieren.`)
};

const fr_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne un emploi enregistré pour générer des questions d'entretien sur mesure.`)
};

const es_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un empleo guardado para generar preguntas de entrevista personalizadas.`)
};

const it_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un lavoro salvato per generare domande di colloquio personalizzate.`)
};

const nl_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een opgeslagen baan om op maat gemaakte sollicitatievragen te genereren.`)
};

const pl_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz zapisaną ofertę pracy, aby wygenerować spersonalizowane pytania rekrutacyjne.`)
};

const fi_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse tallennettu työpaikka luodaksesi räätälöityjä haastattelukysymyksiä.`)
};

const da_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et gemt job for at generere skræddersyede interviewspørgsmål.`)
};

const sv_interview_prepare_subtitle = /** @type {(inputs: Interview_Prepare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett sparat jobb för att generera skräddarsydda intervjufrågor.`)
};

/**
* | output |
* | --- |
* | "Select a saved job to generate tailored interview questions." |
*
* @param {Interview_Prepare_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_subtitle = /** @type {((inputs?: Interview_Prepare_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_subtitle(inputs)
	if (locale === "fr") return fr_interview_prepare_subtitle(inputs)
	if (locale === "es") return es_interview_prepare_subtitle(inputs)
	if (locale === "it") return it_interview_prepare_subtitle(inputs)
	if (locale === "nl") return nl_interview_prepare_subtitle(inputs)
	if (locale === "pl") return pl_interview_prepare_subtitle(inputs)
	if (locale === "fi") return fi_interview_prepare_subtitle(inputs)
	if (locale === "da") return da_interview_prepare_subtitle(inputs)
	if (locale === "sv") return sv_interview_prepare_subtitle(inputs)
	return en_interview_prepare_subtitle(inputs)
});